import PropTypes from 'prop-types';
import React from "react";
import { Row, Col, Alert, Card, CardBody, Container, Form, FormFeedback, Label, Input } from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// Redux
import { connect, useDispatch } from "react-redux";

// import { withRouter, Link } from "react-router-dom"
import { Link, useNavigate } from 'react-router-dom';
import withRouter from 'components/Common/withRouter';

// action
import { userForgetPassword } from "../../store/actions";

// import images
import logoSm from "../../assets/images/logo-sm.png";

const ForgetPasswordPage = props => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [step, setStep] = React.useState("email");
  const [showPassword, setShowPassword] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [success, setSuccess] = React.useState("");
  const version = localStorage.getItem("app_version");
  const generateOTP = () =>
    Math.floor(100000 + Math.random() * 900000).toString();

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      otp: "",
      password: "",
      confirmPassword: ""
    },
    validationSchema: Yup.object({
      email: step === "email"
        ? Yup.string().email().required("Enter Registered Email")
        : Yup.string(),

      otp: step === "otp"
        ? Yup.string().required("Enter OTP")
        : Yup.string(),

      password: step === "reset"
        ? Yup.string().required("Enter password")
        : Yup.string(),

      confirmPassword: step === "reset"
        ? Yup.string()
          .oneOf([Yup.ref("password")], "Passwords must match")
          .required("Confirm password")
        : Yup.string(),
    }),
    onSubmit: values => {
      if (step === "email") sendOtp(values.email);
      if (step === "otp") verifyOtp(values.otp);
      if (step === "reset") resetPassword(values.email, values.password);
    }
  });

  const sendOtp = async (email) => {
    setError("");
    setSuccess("");
    try {
      const tokenRes = await fetch("https://api.kunalsdrumclass.com/api/DI");
      const token = JSON.parse(await tokenRes.text());

      const res = await fetch(
        `https://api.kunalsdrumclass.com/api/ForgotPassword?emailAddress=${email}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const data = await res.json();

      if (data.recordsets?.[0][0].Status === 1) {
        const OTP = generateOTP();
        localStorage.setItem("otp", OTP);
        setTimeout(() => {
          localStorage.removeItem("otp");
        }, 10 * 60 * 1000);
        setStep("otp");
        setSuccess("OTP sent to your registered email.");

        await fetch(
          `https://api.kunalsdrumclass.com/api/SendEmailOTP?emailAddress=${email}&otp=${OTP}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } else {
        setError("Email not found");
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const verifyOtp = (enteredOtp) => {
    setError("");
    setSuccess("");
    const storedOtp = localStorage.getItem("otp");
    if (!storedOtp) return setError("OTP expired");

    if (enteredOtp === storedOtp) {
      setSuccess("OTP verified");
      setStep("reset");
    } else {
      setError("Invalid OTP");
    }
  };

  const resetPassword = async (emailAddress, password) => {
    setError("");
    setSuccess("");
    setLoading(true);
    try {
      const tokenRes = await fetch("https://api.kunalsdrumclass.com/api/DI");
      const token = JSON.parse(await tokenRes.text());

      await fetch("https://api.kunalsdrumclass.com/api/ResetPassword", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ emailAddress, password })
      });

      setSuccess("Password updated successfully");
      navigate("/login");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  document.title = "Forget Password | KDC - Kunal's Drum Class";
  return (
    <React.Fragment>
      <div className="account-pages login-page">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={4}>
              <Card className="forgot-side overflow-hidden">
                <div className="">
                  <div className="text-primary text-center p-4">
                    <h3 className="text-white p-2">Forget Password</h3>
                    <Link to="/index" className="logo logo-admin">
                      <img src={logoSm} height="40" alt="logo" />
                    </Link>
                  </div>
                </div>
                <CardBody className="p-4">

                  {props.forgetError && props.forgetError ? (
                    <Alert color="danger" style={{ marginTop: "13px" }} className="mt-5">
                      {props.forgetError}
                    </Alert>
                  ) : null}
                  {props.forgetSuccessMsg ? (
                    <Alert color="success" style={{ marginTop: "13px" }} className="mt-5">
                      {props.forgetSuccessMsg}
                    </Alert>
                  ) : null}

                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                    className="mt-4">

                    <div className="mb-3">
                      {step === "email" && (
                        <>
                          <Label className="form-label" htmlor="useremail">Email*</Label>
                          <Input
                            name="email"
                            type="email"
                            className="form-control"
                            placeholder="Enter Registered Email"
                            onChange={(e) => {
                              validation.setFieldValue("email", e.target.value.toLowerCase());
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.email}
                            invalid={
                              validation.touched.email && validation.errors.email ? true : false
                            }
                          />
                          {validation.touched.email && validation.errors.email ? (
                            <FormFeedback type="invalid"><div>{validation.errors.email}</div></FormFeedback>
                          ) : null}
                        </>
                      )}

                      {step === "otp" && (
                        <>
                          <Label className="form-label" htmlor="useremail">OTP*</Label>
                          <Input
                            name="otp"
                            type="text"
                            className="form-control"
                            placeholder="Enter OTP"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.otp}
                            invalid={
                              validation.touched.otp && validation.errors.otp ? true : false
                            }
                          />
                          {validation.touched.otp && validation.errors.otp ? (
                            <FormFeedback type="invalid"><div>{validation.errors.otp}</div></FormFeedback>
                          ) : null}
                        </>
                      )}

                      {step === "reset" && (
                        <>
                          <div className="mb-3">
                            <Label className="form-label" htmlor="useremail">Password*</Label>
                            <div className="input-group">
                              <Input
                                name="password"
                                type={showPassword ? "text" : "password"}
                                className="form-control"
                                placeholder="New Password"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.password}
                                invalid={
                                  validation.touched.password && validation.errors.password ? true : false
                                }
                              />
                              <span
                                className="input-group-text"
                                style={{ cursor: "pointer" }}
                                onClick={() => setShowPassword(!showPassword)}
                              >
                                <i className={`fas ${showPassword ? "fa-eye" : "fa-eye-slash"}`}></i>
                              </span>

                              {validation.touched.password && validation.errors.password ? (
                                <FormFeedback type="invalid"><div>{validation.errors.password}</div></FormFeedback>
                              ) : null}
                            </div>
                          </div>

                          <div className="mb-3">
                            <Label className="form-label" htmlor="useremail">Confirm Password*</Label>
                            <div className="input-group">
                              <Input
                                name="confirmPassword"
                                type={showPassword ? "text" : "password"}
                                className="form-control"
                                placeholder="Confirm Password"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.confirmPassword}
                                invalid={
                                  validation.touched.confirmPassword && validation.errors.confirmPassword ? true : false
                                }
                              />
                              <span
                                className="input-group-text"
                                style={{ cursor: "pointer" }}
                                onClick={() => setShowPassword(!showPassword)}
                              >
                                <i className={`fas ${showPassword ? "fa-eye" : "fa-eye-slash"}`}></i>
                              </span>

                              {validation.touched.confirmPassword && validation.errors.confirmPassword ? (
                                <FormFeedback type="invalid"><div>{validation.errors.confirmPassword}</div></FormFeedback>
                              ) : null}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                    {error && <p className="text-danger">{error}</p>}
                    {success && <p className="text-success">{success}</p>}
                    <div className="row  mb-0">
                      <div className="col-12 text-end">
                        <button className="btn btn-primary w-md waves-effect waves-light" type="submit">Reset</button>
                      </div>
                    </div>

                  </Form>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p className="text-white">Remember It ? <Link to="/login" className="fw-medium text-white" > Sign In here </Link> </p>
                <p className="text-white">
                  KDC © {new Date().getFullYear()} | Version: {version} <br/> Developed By <a href="https://www.thebridgecode.com/" className="text-white">The Bridge Code</a>.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

ForgetPasswordPage.propTypes = {
  forgetError: PropTypes.any,
  forgetSuccessMsg: PropTypes.any,
  history: PropTypes.object,
  userForgetPassword: PropTypes.func
};

const mapStatetoProps = state => {
  const { forgetError, forgetSuccessMsg } = state.ForgetPassword;
  return { forgetError, forgetSuccessMsg };
};

export default withRouter(
  connect(mapStatetoProps, { userForgetPassword })(ForgetPasswordPage)
);